import { useRouter } from "next/router";
import { useState } from "react";
import { Header, HeaderBtnContainer, MobileMenu, PrimaryButton } from "./index.styles";
import Icon from "../../../assets/images/Icon.svg";
import LogoBlack from "../../../assets/images/Icon-black.svg";
import LandingUnionWhite from  "../../../assets/images/landing-union-white.svg";
import LandingCross from  "../../../assets/images/landing-cross.svg";

const LandingPageHeader = ({
  fixHeader,
  showModal,
  width,
  offToLandingpage = false,
  headerColor = '#FFFFFF'
}) => {
  const router = useRouter();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const fixedHeaderStyles = {
    position: offToLandingpage ? 'unset' : 'fixed',
    width: '100%',
    top: offToLandingpage ? 'unset' : '0',
    zIndex: '1000',
    backgroundColor: headerColor,
    animation: offToLandingpage ? '' : 'smoothScroll 2s forwards',
  };

  const getStartedClicked = () => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'view_pricing');
    }
    router.push('/pricing' + (router.query.r ? `?r=${router.query.r}` : ''));
  }

  return (
    <div
      style={
        fixHeader && !showModal
          ? {
              ...fixedHeaderStyles,
              boxShadow:
                offToLandingpage || isMobileMenuOpen
                  ? ''
                  : '0px 2px 6px rgba(0, 0, 0, 0.2)',
            }
          : {}
      }
    >
      <Header
        fixHeader={fixHeader && !showModal}
        isMobileMenuOpen={isMobileMenuOpen}
      >
        <div
          style={{ cursor: 'pointer' }}
          onClick={() =>
            offToLandingpage ? router.push('/' + (router.query.r ? `?r=${router.query.r}` : '')) : window.scrollTo(0, 0)
          }
        >
          {(fixHeader && !showModal) || (width <= 600 && isMobileMenuOpen) ? (
            <LogoBlack />
          ) : (
            <Icon />
          )}
        </div>
        {width > 600 ? (
          <HeaderBtnContainer>
            <PrimaryButton fixHeader={fixHeader && !showModal}>
              <a
                target="_blank"
                href="http://resources.gettogather.co/"
                rel="noopener noreferrer"
              >
                FAQ
              </a>
            </PrimaryButton>
            <PrimaryButton
              fixHeader={fixHeader && !showModal}
              style={
                router.pathname === '/pricing'
                  ? {
                      border: 'none',
                      background: 'rgba(34, 34, 36, 0.08)',
                      pointerEvents: 'none',
                    }
                  : {}
              }
              onClick={getStartedClicked}
            >
              Get Started
            </PrimaryButton>
            <PrimaryButton fixHeader={fixHeader && !showModal} showBorder>
              <a
                href={"https://calendly.com/gettogather/30mindemo" + (router.query.r ? `?a3=${router.query.r}` : '')}
                target="_blank"
                onClick={(e) => {
                  if (typeof window.gtag !== 'undefined') {
                    window.gtag('event', 'demo_intent');
                  }
                  if (typeof window.fbq !== 'undefined') {
                    window.fbq('track', 'Lead');
                  }
                  return true;
                }}
              >
                Book a Demo
              </a>
            </PrimaryButton>
            <PrimaryButton
              fixHeader={fixHeader && !showModal}
              onClick={() => router.push('/signin')}
            >
              Sign In
            </PrimaryButton>
          </HeaderBtnContainer>
        ) : (
          <MobileMenu
            fixHeader={fixHeader && !showModal}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            isMobileMenuOpen={isMobileMenuOpen}
          >
            {isMobileMenuOpen ? <LandingCross /> : <LandingUnionWhite />}
            <p>{isMobileMenuOpen ? 'Close' : 'Menu'}</p>
          </MobileMenu>
        )}
      </Header>
      {width <= 600 && isMobileMenuOpen && (
        <HeaderBtnContainer>
          <PrimaryButton fixHeader={fixHeader && !showModal}>
            <a
              target="_blank"
              href="http://resources.gettogather.co/"
              rel="noopener noreferrer"
            >
              FAQ
            </a>
          </PrimaryButton>
          <PrimaryButton
            fixHeader={fixHeader && !showModal}
            style={
              router.pathname === '/pricing'
                ? {
                    border: 'none',
                    background: 'rgba(34, 34, 36, 0.08)',
                    pointerEvents: 'none',
                  }
                : {}
            }
            onClick={getStartedClicked}
          >
            Get Started
          </PrimaryButton>
          <PrimaryButton fixHeader={fixHeader && !showModal} showBorder>
            <a
              href={"https://calendly.com/gettogather/30mindemo" + (router.query.r ? `?a3=${router.query.r}` : '')}
              target="_blank"
              onClick={(e) => {
                if (typeof window.gtag !== 'undefined') {
                  window.gtag('event', 'demo_intent');
                }
                if (typeof window.fbq !== 'undefined') {
                  window.fbq('track', 'Lead');
                }
                return true;
              }}
            >
              Book a Demo
            </a>
          </PrimaryButton>
          <PrimaryButton
            fixHeader={fixHeader && !showModal}
            onClick={() => router.push('/signin')}
          >
            Sign In
          </PrimaryButton>
        </HeaderBtnContainer>
      )}
    </div>
  );
}

export default LandingPageHeader